import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { KullaniciTalep } from 'src/app/models/kullaniciTalep.model';
import { NebisTalepBilgiler } from 'src/app/models/nebisTalep.model';
import { Profil } from 'src/app/models/profil.model';
import { GirisService } from 'src/app/services/giris.service';
import { KullaniciTalepService } from 'src/app/services/kullanici-talep.service';
import { ProfilService } from 'src/app/services/profil.service';
import { YetkiService } from 'src/app/services/yetki.service';

@Component({
  selector: 'sol-menu',
  templateUrl: './sol-menu.component.html',
  styleUrls: ['./sol-menu.component.css']
})
export class SolMenuComponent implements OnInit {

  constructor(private _yetkiService: YetkiService, private girisService: GirisService, private profilService: ProfilService, private kullaniciTalepService: KullaniciTalepService, private router: Router) {
    this.yetkiService = _yetkiService;
  }

  kullaniciTalep: KullaniciTalep[] = [];
  kullaniciTalepNebis: NebisTalepBilgiler[] = [];
  talepSay: number = 0;
  talepSayMenu: number = -1;
  yetkiService: YetkiService;
  kullanici: Profil = new Profil();
  bilgiTamamlamaDurum = false;
  ngOnInit(): void {
    this.talepSayisiMenu();
    this.kullaniciDurum();
  }

  kullaniciDurum() {
    var tckimliknoint: number = +this.girisService.girisBilgi().tckimlikno;
    this.profilService.getByTCKimlikNo(tckimliknoint).subscribe(res => {
      if (res.telDogrulama === true && res.mernisDogrulama === true) {
        this.bilgiTamamlamaDurum = true;
      }
    });
  }

  // ihtisam hocanın apiden kontrol edilecek.
  talepSayisiKontrol() {
    this.kullaniciTalepService.nebisAktifTalepList().subscribe(res => {
      this.talepSay = res.data.length;
      if (this.talepSay > 2) {
        this._yetkiService.error("Hata ! Süreci devam eden en fazla 3 talep gönderebilirsiniz.", 1);
      }
      else {
        this.router.navigateByUrl('/talep-list/yeni')
      }
    });
  }

  talepSayisiMenu() {
    this.kullaniciTalepService.nebisAktifTalepList().subscribe(res => {
      this.talepSayMenu = res.data.length;
    });
  }
}

